import { z } from 'zod'
import { EmailSchema, IsoDateTimeSchema, PasswordSchema, UuidSchema } from '../primitives'

/*
 * POST /api/org/signup — creates the organizer and sets the `org_session` cookie. 409 email_taken.
 * `signupCode` is only needed when the server sets ORG_SIGNUP_CODE (PublicConfig.orgSignupCodeRequired);
 * a missing / wrong code ⇒ 403 invalid_signup_code.
 */
export const OrgSignupRequestSchema = z.object({
  email: EmailSchema,
  password: PasswordSchema,
  name: z.string().trim().min(1, 'Name is required').max(120),
  signupCode: z.string().trim().max(200).optional(),
})
export type OrgSignupRequest = z.infer<typeof OrgSignupRequestSchema>

/* POST /api/org/login — sets the cookie. 401 invalid_credentials. */
export const OrgLoginRequestSchema = z.object({
  email: EmailSchema,
  password: z.string().min(1).max(128),
})
export type OrgLoginRequest = z.infer<typeof OrgLoginRequestSchema>

export const OrganizerSchema = z.object({
  id: UuidSchema,
  email: z.string(),
  name: z.string(),
  createdAt: IsoDateTimeSchema,
})
export type Organizer = z.infer<typeof OrganizerSchema>

/* Response of signup, login and GET /api/org/me (401 when no session). POST /api/org/logout → OkResponse. */
export const OrgMeResponseSchema = z.object({ organizer: OrganizerSchema })
export type OrgMeResponse = z.infer<typeof OrgMeResponseSchema>
